import React from 'react';
import { Select, SelectItem } from '@heroui/react';
import { TFrequencyType, FREQUENCY_OPTIONS } from '../../../types/reportsTypes';

interface DataFrequencyProps {
	value?: TFrequencyType;
	frequencyOptions?: { key: TFrequencyType; label: string }[];
	onChange: (value: TFrequencyType) => void;
}

const DataFrequency: React.FC<DataFrequencyProps> = ({ value, frequencyOptions = FREQUENCY_OPTIONS, onChange }) => {
	return (
		<div className="flex flex-row w-full items-center">
			<span className="mb-1 text-sm font-medium w-1/3 text-msi-midblue-color-500">Data Frequency:</span>

			<Select
				placeholder="Select frequency"
				selectedKeys={value ? [value] : []}
				onSelectionChange={(keys) => {
					const selectedValue = Array.from(keys)[0] as TFrequencyType;
					onChange(selectedValue);
				}}
				className="w-2/3"
				size="sm"
				isRequired
				aria-label='Select Data Frequency'
			>
				{frequencyOptions.map((option) => (
					<SelectItem key={option.key}>{option.label}</SelectItem>
				))}
			</Select>
		</div>
	);
};

export default DataFrequency;
